import React from "react";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import Typography from "@mui/material/Typography";

interface IAnnualPaymentCard {
  price: number;
  isSelected: boolean;
  handleCardClick: () => void;
  enrollmentText: string;
}

const AnnualPaymentCard = ({
  isSelected,
  handleCardClick,
  enrollmentText,
}: IAnnualPaymentCard) => {
  const borderClass = isSelected ? "border-violet-1" : "border-taupe-50";

  return (
    <Box
      role="button"
      aria-pressed={isSelected}
      onClick={handleCardClick}
      className={`relative w-full rounded-lg h-[88px] bg-white border cursor-pointer ${borderClass}`}
      sx={{ transition: "border-color 0.2s ease-in-out" }}
    >
      <Box className="flex items-center gap-4 pl-3 pr-4 py-4 h-full">
        <Radio
          checked={isSelected}
          className={`!p-0 ${isSelected ? "!text-violet-1" : "!text-taupe-50"}`}
          sx={{ width: 24, height: 24 }}
        />
        <Box className="flex-1 min-w-0">
          <Typography
            sx={{
              color: "black.main",
              fontFamily: "geograph-medium, sans-serif",
              fontSize: "14px",
              lineHeight: "20px",
              fontWeight: 500,
            }}
          >
            Annual
          </Typography>
          <Typography
            sx={{
              color: "#908E8D",
              fontFamily: "geograph-regular, sans-serif",
              fontSize: "12px",
              lineHeight: "18px",
              fontWeight: 400,
            }}
          >
            {enrollmentText}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default AnnualPaymentCard;
